import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ThyroidPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Thyroid Disorders</h1>
        <section className="mb-8">
          <p>Thyroid disorders affect the body's metabolism and overall health. Our natural therapies focus on balancing thyroid function, supporting hormone regulation, and improving overall well-being through gentle, effective herbal remedies and lifestyle modifications.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Autoimmune conditions</li>
            <li>Iodine deficiency</li>
            <li>Stress and anxiety</li>
            <li>Genetic factors</li>
            <li>Environmental toxins</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Fatigue and weakness</li>
            <li>Weight changes</li>
            <li>Mood swings</li>
            <li>Hair loss</li>
            <li>Temperature sensitivity</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use thyroid-supporting herbs, adaptogens, and lifestyle modifications to naturally treat thyroid disorders. Our approach focuses on balancing hormone levels, supporting thyroid function, and improving overall health through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural hormone balance</li>
            <li>Improved metabolism</li>
            <li>Better energy levels</li>
            <li>Long-term management</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Balanced diet rich in iodine</li>
            <li>Regular exercise</li>
            <li>Stress management</li>
            <li>Adequate sleep</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Many patients notice improvement within 2-3 months of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Can this treatment replace conventional medication?</strong>
            <p>A: Our natural treatment can complement conventional medication, but any changes should be discussed with your healthcare provider.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Is this treatment suitable for both hyperthyroidism and hypothyroidism?</strong>
            <p>A: Yes, our approach is personalized to address both conditions effectively.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find balance with your thyroid—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default ThyroidPage; 